module.exports = __webpack_public_path__ + "static/media/OP1.97ab28d7.jpg";